
import { defineComponent,PropType,ref,Ref,provide,watchEffect,onMounted,computed } from 'vue';
import File from "@/components/File.component.vue";
import {IFile} from "@/models/files.interface";

export default defineComponent({
  name: 'ListFiles',
  props:{
      files:{
	type: Object as PropType<IFile[]> 
      }      
    },
  components:{
    File
  },
  setup(props){
    let files_list : Ref<IFile[]>= ref([]);
    files_list.value = props.files;

    return {};
  }

});
